export const categorizeFileType = (mimeType) => {
  if (mimeType.startsWith('audio/')) {
    return 'audio';
  } else if (mimeType.startsWith('video/')) {
    return 'video';
  } else if (
    mimeType.startsWith('text/') ||
    [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ].includes(mimeType)
  ) {
    return 'text';
  } else {
    return 'other'; // Default category for unsupported types
  }
};
